const storageKey = 'RV_GUIDE_LOGIN_CANDIDATES';
const maxCandidates = 10;

export type GuideLoginCandidate = {
  guideLoginId: string;
  guideLoginPassword: string;
  lastUsedAt: string;
};

const readCandidates = (): GuideLoginCandidate[] => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw == null) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (x): x is GuideLoginCandidate =>
        typeof x?.guideLoginId === 'string' &&
        typeof x?.guideLoginPassword === 'string' &&
        typeof x?.lastUsedAt === 'string'
    );
  } catch {
    // localStorageが使えない環境（プライベートブラウジング等）では候補機能のみ無効化する
    return [];
  }
};

const writeCandidates = (candidates: GuideLoginCandidate[]): void => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(candidates));
  } catch {
    // 書き込みに失敗しても候補機能を無効化するだけで、呼び出し元の処理は継続させる
  }
};

export const listGuideLoginCandidates = (): GuideLoginCandidate[] => {
  return readCandidates().sort((a, b) => b.lastUsedAt.localeCompare(a.lastUsedAt));
};

export const saveGuideLoginCandidate = (
  guideLoginId: string,
  guideLoginPassword: string
): void => {
  const others = readCandidates().filter(
    (x) => x.guideLoginId !== guideLoginId
  );
  const next = [
    { guideLoginId, guideLoginPassword, lastUsedAt: new Date().toISOString() },
    ...others,
  ]
    .sort((a, b) => b.lastUsedAt.localeCompare(a.lastUsedAt))
    .slice(0, maxCandidates);
  writeCandidates(next);
};

export const removeGuideLoginCandidate = (guideLoginId: string): void => {
  writeCandidates(
    readCandidates().filter((x) => x.guideLoginId !== guideLoginId)
  );
};
